
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import axios from 'axios';
import PickTicketPrintTemplate from '@/components/PickTicketPrintTemplateOptimized.vue';

@Component({
  components: {
    PickTicketPrintTemplate,
  },
})
export default class ShipperPickTicketPrint extends Vue {
  loading = true;
  error = '';
  orderId: number | null = null;

  get pickTicketId(): number {
    return parseInt(this.$route.params.pickTicketId);
  }

  async mounted() {
    await this.fetchOrderId();
  }

  async fetchOrderId() {
    this.loading = true;
    this.error = '';

    try {
      // Fetch the print data to get the orderId
      // The PickTicketPrintTemplate will fetch its own detailed data
      const response = await axios.get(`/api/shipper/pick-ticket/${this.pickTicketId}/print-data`);

      // The response structure is { order: { salesOrderId: ... }, pickTickets: [...], supportingData: {...} }
      this.orderId = response.data.order?.salesOrderId;

      console.log('[ShipperPickTicketPrint] Fetched orderId:', this.orderId, 'for pickTicketId:', this.pickTicketId);

      if (!this.orderId) {
        console.error('[ShipperPickTicketPrint] No orderId found in response:', response.data);
        this.error = 'Unable to determine order ID from pick ticket data';
      }
    } catch (err: any) {
      console.error('Failed to fetch pick ticket print data:', err);

      if (err.response?.status === 404) {
        this.error = 'Pick ticket not found';
      } else if (err.response?.status === 403) {
        this.error = 'You do not have permission to view this pick ticket';
      } else {
        this.error = err.response?.data?.message || 'Failed to load pick ticket data';
      }
    } finally {
      this.loading = false;
    }
  }

  handleCancel() {
    window.close();
    // If window.close() doesn't work (not opened by script), navigate back
    setTimeout(() => {
      this.$router.push('/shipper');
    }, 100);
  }
}
